module.exports = __webpack_public_path__ + "42cf9f0820d16f3ac2c26a7710ce70f2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-Black.ttf
// module id = 1240
// module chunks = 0